import React, { useEffect } from "react";
import "./scss/main.scss";
import Route from "./route.js";
import DisableDevtool from "disable-devtool";
import GlobalLoader from "./components/GlobalLoader";

const App = () => {
  useEffect(() => {
    // DisableDevtool();
  }, []);

  return (
    <>
      <Route />
      <GlobalLoader />
    </>
  );
};

export default App;
